import React, { FC } from 'react'

import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { FullScreenModal } from 'src/Components/FullScreenModal'
import { campaignsList } from 'src/Router/routes'
import SuccessIcon from 'src/Assets/Svg/pages-icons/Success.svg?react'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { GreyTextButton } from 'src/Components/Buttons/GreyTextButton'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
`

const Container = styled.div`
  display: flex;
  max-width: 358px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    max-width: 600px;
  }
`

const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
  font-family: 'Segoe UI';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`

const Text = styled(Title)`
  font-size: 14px;
  font-weight: 400;
`

const StyledSuccessIcon = styled(SuccessIcon)`
  color: ${({ theme }) => theme.color.brandGreen};
`

const StyledGreyTextButton = styled(GreyTextButton)`
  padding-left: 40px;
  padding-right: 40px;
`

export const SuccessCreatedCampaign: FC = () => {
  const navigate = useNavigate()

  const secondParagraph =
    'We will notify you on email and SMS if your campaign is accepted.'

  const handleCloseModal = (): void => {
    navigate(campaignsList)
  }
  return (
    <FullScreenModal open>
      <Wrapper>
        <Container>
          <StyledSuccessIcon width={40} height={40} />
          <div>
            <Title>
              <span>You've created your campaign! 🎉</span>
            </Title>

            <Text>
              It will be reviewed by our A&R team and we’ll get back to you
              within 15-45 min.
            </Text>
            <Text>{secondParagraph}</Text>
          </div>

          <StyledGreyTextButton onClick={handleCloseModal}>
            Go to Campaigns
          </StyledGreyTextButton>
        </Container>
      </Wrapper>
    </FullScreenModal>
  )
}
